import ProductTypeService from "@/services/ProductTypeService.js";
import productTypeModel from "@/models/productType";
import map from "lodash/map";

export const namespaced = true;

export const state = {
  productsTypes: []
};

export const mutations = {
  SET_PRODUCTS_TYPES(state, productsTypes) {
    state.productsTypes = map(productsTypes.items, productType => {
      const _p = new productTypeModel();
      _p.hydrate(productType);

      return _p;
    });
  }
};

export const actions = {
  fetchProductsTypes({commit}) {
    return ProductTypeService
      .getProductsTypes()
      .then(response => {
        commit("SET_PRODUCTS_TYPES", response.data);
      })
    /*.catch(error => {
      const notification = {
        type: "error",
        message:
          "There was a problem fetching products types: " + error.message
      };
      dispatch("notification/add", notification, { root: true });
    });*/
  }
};
export const getters = {
  getProductTypeById: state => id => {
    return state.productsTypes.find(productType => productType.id === id);
  }
};
